import React from "react";
import { format, parseISO } from "date-fns";
import { JdsButton } from "../../../components/jds/JdsButton";
import { JdsTag } from "../../../components/jds/JdsTag";
import { scopeLabel } from "../utils/scopeCatalog";

const STATUS_LABELS = {
  Active: "Ativo",
  Inactive: "Inativo",
  Pending: "Pendente",
};

const formatDate = isoInstant =>
  isoInstant ? format(parseISO(isoInstant), "dd/MM/yyyy") : "—";

const STATUS_COLORS = {
  Active: "success",
  Inactive: "neutral",
  Pending: "warning",
};

const describeScopeCount = scopes =>
  scopes.length === 1 ? "1 produto" : `${scopes.length} produtos`;

// As colunas dependem dos handlers da tela, então saem de uma função em vez de
// serem uma constante de módulo.
export const buildClientColumns = ({ onShowApiKey, onRotate, onEditScopes }) => [
  {
    name: "Nome",
    selector: row => row.name,
    sortable: true,
    grow: 2,
  },
  {
    name: "Cliente da Jusfy",
    // null = cliente interno do calculator-api ou cliente desvinculado. A rota
    // deixou de filtrar por vínculo, então essa linha é normal na lista.
    selector: row => row.backendClientId ?? "Não vinculado",
    sortable: true,
    width: "180px",
  },
  {
    name: "Status",
    selector: row => STATUS_LABELS[row.status] ?? row.status,
    cell: row => (
      <JdsTag
        label={STATUS_LABELS[row.status] ?? row.status}
        color={STATUS_COLORS[row.status] ?? "neutral"}
      />
    ),
    sortable: true,
    width: "120px",
  },
  {
    name: "Produtos",
    // `?? []` até a FT-2600 subir: antes dela o proxy não devolve `scopes`
    selector: row => (row.scopes ?? []).length,
    // a contagem cabe na coluna; a lista inteira fica no tooltip
    cell: row => {
      const scopes = row.scopes ?? [];
      return (
        <span
          title={scopes.map(scopeLabel).join("\n") || "Nenhum produto liberado"}
        >
          {scopes.length === 0 ? (
            <JdsTag label={describeScopeCount(scopes)} color="error" />
          ) : (
            describeScopeCount(scopes)
          )}
        </span>
      );
    },
    sortable: true,
    width: "130px",
  },
  {
    name: "Criado em",
    selector: row => formatDate(row.createdAt),
    sortable: true,
    width: "130px",
  },
  {
    name: "Ações",
    cell: row => (
      <div className="vinculacao-row-actions">
        {/* Edita só os produtos: nome e vínculo continuam decididos na
            criação. */}
        <JdsButton
          variant="outlined"
          color="neutral"
          size="sm"
          onClick={() => onEditScopes(row)}
        >
          Editar produtos
        </JdsButton>
        <JdsButton
          variant="outlined"
          color="neutral"
          size="sm"
          onClick={() => onShowApiKey(row)}
        >
          Ver API key
        </JdsButton>
        {/* separado do "Ver API key" de propósito: rotacionar mata a key atual
            na hora, e os dois não podem ser confundidos */}
        <JdsButton
          variant="outlined"
          color="error"
          size="sm"
          onClick={() => onRotate(row)}
        >
          Rotacionar
        </JdsButton>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    width: "400px",
  },
];
